import { removeValue } from './removeValue.js';

// @param {Function} test Accepts value to test, returns true if matches or false if doesn't.
export const removeValueMatching = (arr, test) => {
  const value = arr.find(test);

  return removeValue(arr, value);
};